import React, { Component} from 'react';
import { connect } from "react-redux";
import { Row, Col, Button, Modal, ModalHeader, ModalFooter, Card, CardBody, CardHeader } from "reactstrap";
import { NotificationManager } from "react-notifications";
import LoadingSpinner from "../../components/LoadingSpinner/index";
import DataTable from "../../components/Table/Table";
import "react-table/react-table.css";
import { Link } from "react-router-dom";
import {getOidcConfigs, deleteOidcConfig, setOidcPageInfo} from "../../actions/actionOidc.js"

class OidcConfig extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modal: false,
            filterId: null,
        };

        this.cancelDelete = this.cancelDelete.bind(this);
        this.deleteConfirm = this.deleteConfirm.bind(this);
        this.deleteOidcAction = this.deleteOidcAction.bind(this);
        this.handleDeleteSuccess = this.handleDeleteSuccess.bind(this);
        this.handleDeleteError = this.handleDeleteError.bind(this);
    }

    componentDidMount() {
        this.props.getOidcConfigs();
    }

    deleteConfirm(oidcConfigId){
        this.setState({modal: !this.state.modal,
            oidcConfigId: oidcConfigId});
    }

    cancelDelete(){
        this.setState({modal: !this.state.modal});
    }

    deleteOidcAction(){
        this.props.deleteOidcConfig(this.state.oidcConfigId).
        then(() => this.handleDeleteSuccess()).
        catch(() => this.handleDeleteError());
    }

    handleDeleteSuccess(){
        const {deleteOidcErrorMessage} = this.props;
        if(deleteOidcErrorMessage) {
            NotificationManager.error(deleteOidcErrorMessage,"Delete OIDC Config Failed", 3000);
        }else{
            NotificationManager.success("Successfully Deleted OIDC Config","Delete OIDC Config", 3000);
            this.setState({modal: false});
            this.props.getOidcConfigs();
        }
    }

    handleDeleteError(){
        const {deleteOidcError} = this.props;
        if(deleteOidcError){
            NotificationManager.error(deleteOidcError,"Failed to Delete OIDC Config", 3000);
            this.props.history.push("/oidc");
        }else{
            NotificationManager.error("Failed to Delete OIDC Config","Delete OIDC Config", 3000);
            this.props.history.push("/oidc");
        }
    }

    render() {
        if (this.props.getOidcLoading) {
            return (<div> <LoadingSpinner /></div>);
        }
        
        const {oidc_configs} = this.props;

        const tableColumns = [
            {
                type: "text",
                name: "Display Name",
                accessor: "display_name",
                filterable: true,
                sortable: true,
            },
            {
                type: "flag",
                name: "Enabled",
                accessor: "enabled",
                filterable: true,
                sortable: true,
            },
            {
                type: "flag",
                name: "Auto Login",
                accessor: "auto_login",
                filterable: true,
                sortable: true,
            },
        ];

        const actions = [
            { id: "view", icon: "fa-eye", description: "View" },
            { id: "edit", icon: "fa-pencil", description: "Edit" },
            { id: "delete", icon: "fa-trash", description: "Delete" },
        ];

        const onAction = (action, item) => {
            switch (action) {
                case "view":
                    this.props.history.push(`/viewoidc/${item.oidc_id}`);
                break;

                case "edit":
                    this.props.history.push(`/updateoidc/${item.oidc_id}`);
                break;

                case "delete":
                    this.deleteConfirm(item.oidc_id);
                break;
            }
        }

        return(
            <div className="profile-page">
                <Row>
                    <Col sm={{ size: 10, order: 3, offset: 1 }}>
                        <Card >
                            <CardHeader>
                            <div className="title-head">
                                <i className="fa fa-book"></i> <strong>OpenID Configurations</strong></div>
                                <Link className="pull-right add-btn" to={{ pathname: "/createoidc" }}>
                                    <button className="pull-right adduser-btn" size="sm" color="dark">
                                    <i className="fa fa-plus" aria-hidden="true"></i>
                                    Add Config
                                    </button>
                                </Link>
                            </CardHeader>
                            <CardBody className="p-0">
                                <DataTable
                                    id="oidcs"
                                    data={oidc_configs}
                                    columns={tableColumns}
                                    actions={actions}
                                    onAction={onAction}
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>

                <Modal isOpen={this.state.modal} toggle={this.cancelDelete} centered={true} className="user-modal">
                    <ModalHeader toggle={this.cancelDelete}>Are you sure you want to delete this config?
                    </ModalHeader>
                    <ModalFooter>
                        <Button onClick={this.cancelDelete} size="sm" 
                        className="cancel-button"
                        color=" basic"> Close</Button>
                        <Button onClick={this.deleteOidcAction} 
                        className="delete-button"
                        size="sm" color="danger">Delete</Button>
                    </ModalFooter>
                </Modal>
            </div>
        );
    }

}

export default connect(state => ({
        oidc_configs: state.oidc.oidc_configs || [],
        getOidcLoading: state.oidc.getOidcLoading || false,
        getOidcErrorMessage: state.oidc.getOidcErrorMessage || false,
        getOidcError: state.oidc.getOidcError || null,
        deleteOidcErrorMessage: state.oidc.deleteOidcErrorMessage || null,
        deleteOidcError: state.oidc.deleteOidcError || null,
        deletedOidc: state.oidc.deletedOidc || null,
        deleteOidcLoading: state.oidc.deleteOidcLoading || null,
        pages : {pageSize : state.oidc.pageSize, pageNo : state.oidc.pageNo},
    }),
    dispatch => ({
        getOidcConfigs: () => dispatch(getOidcConfigs()),
        deleteOidcConfig: (data) => dispatch(deleteOidcConfig(data)),
        setPageInfo : (data)=> dispatch(setOidcPageInfo(data)),

    }))(OidcConfig);
